module.exports = __webpack_public_path__ + "img/logo.b26a4c17.png";